import { defineComponent as _defineComponent } from 'vue'
import { Video } from '@sh/components/Layout/TutorialDropdown';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';

interface Props {
  video: Video;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoCard.ts',
  props: {
    video: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click', value: Video): void;
}), expose: any, slots: any, attrs: any }) {




return { __sfc: true,emits, OptimizerIconV2 }
}

})